export enum OrderStatus {
  Booked = "BOOKED",
  CarrierAssigned = "CARRIER_ASSIGNED",
  InProgress = "IN_PROGRESS",
  WaitingForTourReview = "WAITING_FOR_TOUR_REVIEW",
  ReadyToInvoice = "READY_TO_INVOICE",
  Invoiced = "INVOICED",
  Cancelled = "CANCELLED"
}

const sortedOrderStatus = [
  OrderStatus.Booked,
  OrderStatus.CarrierAssigned,
  OrderStatus.InProgress,
  OrderStatus.WaitingForTourReview,
  OrderStatus.ReadyToInvoice,
  OrderStatus.Invoiced,
  OrderStatus.Cancelled
];

export const hasStatusReachedStatus = (
  status: OrderStatus,
  toReach: OrderStatus
): boolean => {
  return (
    sortedOrderStatus.indexOf(status) >= sortedOrderStatus.indexOf(toReach)
  );
};

export const isStatusBeforeStatus = (
  status: OrderStatus,
  toReach: OrderStatus
): boolean => {
  return (
    sortedOrderStatus.indexOf(status) < sortedOrderStatus.indexOf(toReach)
  );
};
